// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Person24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Person24CircleFilled: FC<Person24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-2.825-17.175C13.958 15.608 14.9 16 16 16s2.042-.392 2.825-1.175C19.608 14.042 20 13.1 20 12s-.392-2.042-1.175-2.825C18.042 8.392 17.1 8 16 8s-2.042.392-2.825 1.175C12.392 9.958 12 10.9 12 12s.392 2.042 1.175 2.825ZM8 21.2V24h16v-2.8c0-.567-.146-1.087-.438-1.563A2.917 2.917 0 0 0 22.4 18.55a14.841 14.841 0 0 0-3.15-1.163A13.76 13.76 0 0 0 16 17c-1.1 0-2.183.13-3.25.387A14.841 14.841 0 0 0 9.6 18.55c-.483.25-.87.613-1.162 1.087A2.93 2.93 0 0 0 8 21.2Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Person24CircleFilled;
